<template>
  <div class="lke-bg" v-loading="loading">
    <div class="lke-top">
      <div class="lke-top-title">
        <i class="el-icon-s-home"></i>
        <span>当前位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/" style="text-decoration: none">
              <el-link>首页</el-link>
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/xwzxList" style="text-decoration: none">
              <el-link style="cursor: pointer" type="info">新闻</el-link>
            </router-link>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="lke-text-bg">
      <div class="lke-text-tit">
        <div class="lke-text-tit-top">
          <h4>{{ info.title }}</h4>
        </div>
        <div class="lke-text-tit-fot">
          <span>发布时间：{{ info.releaseTime | addtime }} </span>
          <span>【点击次数：{{ info.views + 1 }}】</span>
          <span>作者：{{ info.user }}</span>
        </div>
      </div>
      <div class="lke-text" v-html="info.content"></div>
      <div class="lke-text-fot">
        <!-- <p>上一篇:<span>没有了</span></p>
                <p>下一篇:<span>没有了</span></p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getnoticeOne } from "@/api/index";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      id: "",
      info: {},
      loading: false,
    };
  },
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  computed: {},
  created() {
    this.id = this.$route.params.id;
    this.getInfo();
  },
  mounted() {},
  watch: {},
  methods: {
    getInfo() {
      this.loading = true;
      getnoticeOne(this.id).then((response) => {
        this.info = response;
      });
      this.loading = false;
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
::v-deep.lke-text img {
  max-width: 100% !important;
}
.lke-text img {
  max-width: 100% !important;
}
.lke-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-bottom: 60px; */
}
.lke-top {
  width: 944px;
  padding: 20px 40px;
}
.lke-top-title {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.lke-top-title > i {
  color: #2890f4;
  font-size: 20px;
}
.lke-top-title > span {
  margin-left: 5px;
  margin-right: 10px;
}
.lke-text-bg {
  width: 904px;
  margin: 0 40px;
  padding: 20px;
  background: #fff;
}
.lke-text-tit {
  padding-bottom: 20px;
  border-bottom: 1px dashed #c0bbc2;
}
.lke-text-tit-top {
  text-align: center;
  color: #753592;
  font-size: 24px;
  letter-spacing: 1px;
  padding-bottom: 10px;
  font-weight: normal;
}
.lke-text-tit-fot {
  text-align: center;
  color: #bababa;
  font-size: 12px;
}
.lke-text-tit-fot > span {
  padding: 0 5px;
}
.lke-text {
  padding: 20px;
  letter-spacing: 1px;
  border-bottom: 1px dashed #c0bbc2;
  line-height: 1.6;
  text-indent: 2em;
}
.lke-text > span {
  font-size: 16px;
  line-height: 150%;
  font-family: 宋体;
  text-indent: 32px;
  font-weight: bold;
}
.lke-text > p {
  font-size: 16px;
  line-height: 150%;
  text-indent: 2em;
}
.lke-text-fot {
  font-size: 14px;
  padding: 30px 20px;
}
.lke-text-fot > p {
  line-height: 300%;
  color: #c92748;
}
.lke-text-fot > p span {
  padding-left: 10px;
  color: #5d5c5b;
  cursor: pointer;
}
.lke-text-fot > p span:hover {
  color: #ec6f00;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/xwzx/xwzx.vue